import LazyLoad from "vanilla-lazyload";
import owlCarousel from 'owl.carousel';
import selectize from 'selectize';
import jscroll from 'jscroll';

$(document).ready(function () {

    $('.scrollToSection').click(function (e) {
        e.preventDefault();
        $('html, body').stop().animate({
            scrollTop: $($(this).data('target')).offset().top - 104
        }, 800);

        if ($('.top-info').length) {
            $('.top-info').slideUp();
            $('.page-top, .home-slider, .prod-top, .con-top, .news-top').css('margin-top', $('.nav').height());
        }
    });

    // Kontrola, ci existuje hash v url, nastavenie aktivneho tabu a animovane odskrolovanie
    function setActiveTabAndScroll (hash) {
        if (hash && hash.substr(0, 1) == "#") {
            var offsetTop,
                activeTab,
                tabTitle;

            if ($('.top-info').length) {
                $('.top-info').slideUp();
                $('.page-top, .home-slider, .prod-top, .con-top, .news-top').css('margin-top', $('.nav').height());
                $('.top-info').addClass('stop');
            }

            setTimeout(function () {
                $('.top-info').removeClass('stop');
            }, 1200);

            if (hash == '#kontakt') {
                setTimeout(function () {
                    $('html, body').stop().animate({
                        scrollTop: $('.prod__con').offset().top - 104
                    }, 800);
                    document.title = $('.page-tabs__item--active').text();
                }, 20);
                return false;
            }

            $('.page-tabs .page-tabs__item').each(function (event) {
                if ($(this).attr('href') == hash) {
                    $('.page-tabs .page-tabs__item').removeClass('page-tabs__item--active');
                    $(this).addClass('page-tabs__item--active');
                    activeTab = $(this).attr('data-tab');
                    if ($(this).data('title')) {
                        tabTitle = $(this).data('title');
                    } else {
                        tabTitle = $(this).text();
                    }
                }
            });

            $('.page-tabs-content').each(function (event) {
                var tab = $(this).attr('data-tab');
                if (tab == activeTab) {
                    $('.page-tabs-content').hide();
                    $(this).fadeIn();
                    offsetTop = $(hash).offset().top;
                }
            });

            $('html, body').stop().animate({
                scrollTop: offsetTop - 180
            }, 1200);
            //location.hash = hash;

            //Nastavíme v kontakte aj product title a produkt title pre formulár
            //Zároven zmenime aj page <title>
            if (tabTitle) {
                if ($('#contactTitle').length) {
                    $('#contactTitle strong').html(tabTitle);
                    $('#formProduct').val(tabTitle);
                }

                if (tabTitle.length != 0) {
                    document.title = tabTitle + ' ~ Asseco Solution';
                }
            } else {

                $('html, body').stop().animate({
                    scrollTop: $(location.hash).offset().top - 104
                }, 800);

            }
        }
    }

    function openAndScrollToTab (query) {
        var query = query.split('&')[0];

        //Ak je tab v tabe
        if (query.indexOf('mobilny-skladnik') !== -1) {
            var index = 0;
        } else if (query.indexOf('mobilny-obchodnik') !== -1) {
            var index = 1;
        } else if (query.indexOf('mobilny-manazer') !== -1 || query.indexOf('eshop') !== -1) {
            var index = 2;
        }

        setTimeout(function () {
            //Ak je tab v tabe
            if (typeof index !== 'undefined') {
                if (query.indexOf('eshop') !== -1) {
                    document.querySelectorAll('.con-tabs__item[data-url="objednavkove-systemy"] a')[0].click();
                } else {
                    document.querySelectorAll('.con-tabs__item[data-url="mobilne-riesenia"] a')[0].click();
                }
                document.querySelectorAll('.prod-tabtab__link')[index].click();
                $('.prod-facts__tabs').scrollLeft(1000);
            } else {
                $('.con-tabs__item[data-url="' + query + '"]').trigger('click');
            }
        }, 20);
        if ($('.prod__facts').length) {
            setTimeout(function () {
                $('html, body').stop().animate({
                    scrollTop: $('.prod__facts').offset().top - 104
                }, 800);
            }, 30);
        }
    }

    //scroll na tab v produktoch
    if (location.search) {

        let segmentActiveTab = null;
        location.search.split('&').forEach(segment => {
            if (segment.indexOf('=') === -1) {
                segmentActiveTab = segment.replace('?', '');
            }
        })

        if (segmentActiveTab) {
            openAndScrollToTab(segmentActiveTab);
        }
    }

    // Kontrola hashu pri naloadovani stranky
    setActiveTabAndScroll(location.hash);

    // Pridanie tiena pod navbar
    function scrolled () {
        if ($(window).scrollTop() > 0) {
            $('.nav').addClass('nav--scrolled');
            if ($('.top-info').length && !$('.top-info').hasClass('stop')) {
                $('.top-info').slideUp();
                $('.page-top, .home-slider, .prod-top, .con-top, .news-top').css('margin-top', $('.nav').height());
            }
        } else {
            if ($('.top-info').length && !$('.nav__burger--active').length && !$('.top-info').hasClass('stop')) {
                $('.top-info').slideDown(function () {
                    $('.page-top, .home-slider, .prod-top, .con-top, .news-top').css('margin-top', $('.nav').height());
                });
            }
            $('.nav').removeClass('nav--scrolled');
        }
    }

    scrolled();

    $(window).on('scroll', function (event) {
        scrolled();
    });

    // Burger
    $('.nav__burger').on('click', function (event) {
        if ($(this).hasClass('nav__burger--active')) {
            $(this).removeClass('nav__burger--active');
            $('.nav__menu').stop().slideUp();
        } else {
            $(this).addClass('nav__burger--active');
            $('.nav__menu').stop().slideDown();
            if ($('.top-info').length) {
                $('.top-info').slideUp(function () {
                    $('.page-top, .home-slider, .prod-top, .con-top, .news-top').css('margin-top', $('.nav').height());
                });
            }
        }
    });

    // Submenu
    $('.menu__item').on('mouseenter', function (event) {
        var link = $(this).children('.menu__link'),
            submenu = $(this).children('.submenu');

        if (link.hasClass('menu__link--has-submenu')) {
            link.addClass('menu__link--submenu-open');
            submenu.stop().slideDown();
        }
    })

    $('.menu__item').on('mouseleave', function (event) {
        var link = $(this).children('.menu__link'),
            submenu = $(this).children('.submenu');

        if (link.hasClass('menu__link--has-submenu')) {
            submenu.stop().slideUp();
            link.removeClass('menu__link--submenu-open');
        }
    });

    if (window.matchMedia('(min-width: 1250px)').matches) {
        $('.submenu__item').on('mouseenter', function (event) {
            $(this).children('.menu-box').stop().fadeIn();
        }).on('mouseleave', function (event) {
            $(this).children('.menu-box').stop().hide();
        });
    }

    // Klikanie na page taby
    $('.page-tabs .page-tabs__item, .stat-sa-partnerom').on('click', function (event) {
        setActiveTabAndScroll($(this).attr('href'));
    });

    // Klikanie na obsahove taby
    $('.prod-facts__tabs.con-tabs .con-tabs__item').on('click', function (event) {
        event.preventDefault();
        let prevLink = $(this).parent().find('.con-tabs__item--active');
        prevLink.removeClass('con-tabs__item--active');
        $(this).addClass('con-tabs__item--active');

        //nastavíme aj hash v url ak máme
        // if ($(this).data('url')) {
        //     window.location.hash = $(this).data('url');
        // }

        var activeTab = $(this).attr('data-tab');

        //nastavenie url
        if ($(this).data('url')) {
            let search = location.search.replace('&' + prevLink.data('url'), '').replace('?' + prevLink.data('url'), '');

            location.search.split('&').forEach(segment => {
                if (segment.indexOf('=') === -1) {
                    search = search.replace('&' + segment, '').replace('?' + segment, '');
                }
            })

            if (window.location.search && window.location.search.indexOf($(this).data('url')) === -1) {
                if (search) {
                    window.history.pushState({}, null, location.pathname + search + '&' + $(this).data('url'));
                } else {
                    window.history.pushState({}, null, location.pathname + '?' + $(this).data('url'));
                }
            } else if (window.location.search && window.location.search.indexOf($(this).data('url')) !== -1) {
                //
            } else {
                window.history.pushState({}, null, location.pathname + '?' + $(this).data('url'));
            }
        }

        $('.con-tabs-content').each(function (event) {
            let tab = $(this).attr('data-tab');
            if (tab == activeTab) {
                $(this).fadeIn();
            } else {
                $(this).hide();
            }
        });

        if ($('.prod-top__title').text().toLowerCase().indexOf('helios') !== -1) {
            if ($(this).data('url') == 'o-systeme') {
                window._adftrack.push({
                    HttpHost: 'track.adform.net',
                    pm: 2460324,
                    divider: encodeURIComponent('|'),
                    pagename: encodeURIComponent('Helios_Tabs_Systeme')
                });
            } else if ($(this).data('url') == 'podpora-a-sluzby') {
                window._adftrack.push({
                    HttpHost: 'track.adform.net',
                    pm: 2460324,
                    divider: encodeURIComponent('|'),
                    pagename: encodeURIComponent('Helios_Tabs_podpora-a-sluzby')
                });
            } else if ($(this).data('url') == 'moduly-systemu') {
                window._adftrack.push({
                    HttpHost: 'track.adform.net',
                    pm: 2460324,
                    divider: encodeURIComponent('|'),
                    pagename: encodeURIComponent('Helios_Tabs_Moduly')
                });
            } else if ($(this).data('url') == 'technicke-informacie') {
                window._adftrack.push({
                    HttpHost: 'track.adform.net',
                    pm: 2460324,
                    divider: encodeURIComponent('|'),
                    pagename: encodeURIComponent('Helios_Tabs_technicke')
                });
            } else if ($(this).data('url') == 'helios-zoom') {
                window._adftrack.push({
                    HttpHost: 'track.adform.net',
                    pm: 2460324,
                    divider: encodeURIComponent('|'),
                    pagename: encodeURIComponent('Helios_Tabs_Zoom')
                });
            }
        }

        if ($('.prod-top__title').text().toLowerCase().indexOf('applus') !== -1) {
            if ($(this).data('url') == 'o-systeme') {
                window._adftrack.push({
                    HttpHost: 'track.adform.net',
                    pm: 2460324,
                    divider: encodeURIComponent('|'),
                    pagename: encodeURIComponent('Applus_Tabs_Systeme')
                });
            } else if ($(this).data('url') == 'podpora-a-sluzby') {
                window._adftrack.push({
                    HttpHost: 'track.adform.net',
                    pm: 2460324,
                    divider: encodeURIComponent('|'),
                    pagename: encodeURIComponent('Applus_Tabs_podpora-a-sluzby')
                });
            } else if ($(this).data('url') == 'technicke-informacie') {
                window._adftrack.push({
                    HttpHost: 'track.adform.net',
                    pm: 2460324,
                    divider: encodeURIComponent('|'),
                    pagename: encodeURIComponent('Applus_Tabs_technicke')
                });
            }
        }
    });

    // Klikanie na produktove taby
    $('.prod-grid__tabs.con-tabs .con-tabs__item').on('click', function (event) {
        if (!$(this).hasClass('con-tabs__item--blue')) {
            event.preventDefault();
        } else {
            window.location = $(this).find('.con-tabs__link').attr('href');
            return false;
        }
        $(this).siblings().removeClass('con-tabs__item--active');
        $(this).addClass('con-tabs__item--active');

        var activeProdCategory = $(this).attr('data-category');

        $('.prod-grid__box').each(function (event) {
            var prodCategories = $(this).attr('data-category').split(' ');
            if (activeProdCategory == 'vsetky' || $.inArray(activeProdCategory, prodCategories) >= 0) {
                $(this).hide().fadeIn();
            } else {
                $(this).hide();
            }
        });
    });

    if ($('.con-tabs__item--active').length) {
        let segmentActiveTab = null;
        location.search.split('&').forEach(segment => {
            if (segment.indexOf('=') === -1) {
                segmentActiveTab = segment.replace('?', '');
            }
        })

        if (!segmentActiveTab) {
            $('.con-tabs__item--active').trigger('click');
        }
    }

    // Filtre na referenciach
    function referenceFilter () {
        $.ajax({
            method: $('#clients__filter').attr('method'),
            url: $('#clients__filter').attr('action'),
            data: {
                category: $('#filter__cat').val(),
                product: $('#filter__prod').val(),
                name: $('.search-text__input').val(),
                _token: Asseco._token,
            },
            success: function (data) {
                $('.clients__logos').html(data);
                window.lazyLoadInstance.update();
            },
        });
    }
    $('.clients__filter .filter__select').on('change', function (event) {
        referenceFilter();
    });
    $('.clients__filter .search-text__input').on('keyup', function (event) {
        referenceFilter();
    });

    // Filtre na partneroch
    function partnerFilter () {
        $.ajax({
            method: $('.par-list__filter').attr('method'),
            url: $('.par-list__filter').attr('action'),
            data: {
                country: $('#filter__country').val(),
                product: $('#filter__prod').val(),
                name: $('.search-text__input').val(),
                _token: Asseco._token,
            },
            success: function (data) {
                $('.par-list__table').html(data);
            },
        });
    }
    $('.par-list__filter .filter__select').on('change', function (event) {
        partnerFilter();
    });
    $('.par-list__filter .search-text__input').on('keyup', function (event) {
        partnerFilter();
    });

    // Top slider
    $('.home-slider__slider').owlCarousel({
        items: 1,
        loop: true,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        nav: false,
        dots: true,
        // autoplay: true,
        // autoplayTimeout: 5000,
        // autoplayHoverPause: false,
    });
    // Predchadzajuci slide
    $('.home-slider__arrow--left').on('click', function (event) {
        $('.home-slider__slider.owl-carousel').trigger('prev.owl.carousel');
    });
    // Nasledujuci slide
    $('.home-slider__arrow--right').on('click', function (event) {
        $('.home-slider__slider.owl-carousel').trigger('next.owl.carousel');
    });

    // Slider v sekcii Referencie
    $('.ref-slider__slider').owlCarousel({
        items: 1,
        loop: true,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
    });
    // Predchadzajuci slide
    $('.ref-slider__arrow--left').on('click', function (event) {
        $(this).parent().find('.owl-carousel').trigger('prev.owl.carousel');
    });
    // Nasledujuci slide
    $('.ref-slider__arrow--right').on('click', function (event) {
        $(this).parent().find('.owl-carousel').trigger('next.owl.carousel');
    });

    // Slider v sekcii Povedali o nas na kameru
    $('.cam-slider__slider:not(.owl-single)').owlCarousel({
        items: 1,
        margin: 100,
        loop: true,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        nav: false,
        dots: false,
        autoplay: false,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
    });
    // Predchadzajuci slide
    $('.cam-slider__arrows--left').on('click', function (event) {
        $('.cam-slider__slider.owl-carousel').trigger('prev.owl.carousel');
    });
    // Nasledujuci slide
    $('.cam-slider__arrows--right').on('click', function (event) {
        $('.cam-slider__slider.owl-carousel').trigger('next.owl.carousel');
    });

    $('.cam-slider__slider.owl-single').owlCarousel({
        items: 1,
        margin: 100,
        loop: false,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        nav: false,
        dots: false,
        autoplay: false,
        autoplayHoverPause: true,
    });

    // Zatvorenie modalu po stlaceni ESC
    $(document).on('keydown', function (event) {
        if (event.keyCode == 27) {
            $('.video-modal__iframe').attr('src', "");
            $('.modal').fadeOut();
            $('.help-modal').fadeOut();
        }
    });
    // Zatvorenie modalu po kliknut na X alebo kliknutim mimo obsahu
    $('.modal, .modal__close, .help-modal__close').on('click', function (event) {
        if (event.target !== this)
            return;

        $('.video-modal__iframe').attr('src', "");
        $('.modal').fadeOut();
        $('.help-modal').fadeOut();
    });

    // Otvorenie modalu s videom
    $('.video').on('click', function (event) {
        $('.video-modal__iframe').attr('src', $(this).attr('data-url'));
        $('.video-modal').fadeIn();

        //play helios videos
        if ($('.prod-top__title').text().toLowerCase().indexOf('helios') !== -1) {
            window._adftrack.push({
                HttpHost: 'track.adform.net',
                pm: 2460324,
                divider: encodeURIComponent('|'),
                pagename: encodeURIComponent('YTB_play_helios')
            });
        }
        //play applus videos
        if ($('.prod-top__title').text().toLowerCase().indexOf('applus') !== -1) {
            window._adftrack.push({
                HttpHost: 'track.adform.net',
                pm: 2460324,
                divider: encodeURIComponent('|'),
                pagename: encodeURIComponent('YTB_play_applus')
            });
        }
    });

    // Otvorenie modalu so searchom
    $('.menu__link--search').on('click', function (event) {
        event.preventDefault();
        $('.search-modal').fadeIn();
        $('.search-modal__input').focus();
    });

    // Otvorenie modalu s pomocou
    $('.menu__link--help, .search-res__link--help').on('click', function (event) {
        event.preventDefault();
        $('.help-modal').fadeIn();
    });

	$('.prod-docs__link').on('click', function(event) {
		if ($(this).attr('href') == '#') {
			event.preventDefault();
			$('.modalDocs').fadeIn();
			$('.modalDocs').find('#material').val($(this).attr('data-url'));
		}
	});

    // Selectize.js na selektoch
    $('.select').selectize({
        create: true,
    });
    $('.selectize-input input').prop('readonly', true);

    // Detail partnera
    $(document).on('click', '.par-table__header', function (event) {
        if ($(this).parents('.par-table__item').hasClass('par-table__item--active')) {
            $('.par-table__item').removeClass('par-table__item--active').children('.par-table__content').slideUp();
        } else {
            $('.par-table__item').removeClass('par-table__item--active').children('.par-table__content').slideUp();
            $(this).parents('.par-table__item').toggleClass('par-table__item--active').children('.par-table__content').slideToggle();
        }
    });


    //Kontakt formulare
    $('._contact_form').submit(function (e) {
        e.preventDefault();

        var $form = $(this);

        if ($('#formProduct').val() == 'Asseco APplus') {
            window.adf && adf.ClickTrack(this, 2460324, 'Click_Button_formular_applus', {});
        } else if ($('#formProduct').val() == 'Asseco HELIOS iNuvio') {
            window.adf && adf.ClickTrack(this, 2460324, 'Click_Button_formular_helios', {});
        }

        $.ajax({
            method: 'POST',
            url: '/form',
            data: $form.serializeArray(),
            beforeSend: function () {
                $form.find('.has-error').removeClass('has-error');
                $form.find('button').prop('disabled', true);
            },
            error: function (data) {
                $.each(data.responseJSON.errors, function (key, value) {
                    if (key) {
                        if (key == 'check') {
                            $form.find('input[name="' + key + '"]').next().addClass('has-error');
                        } else {
                            $form.find('input[name="' + key + '"], textarea[name="' + key + '"]').parent().addClass('has-error');
                        }
                    }
                });
                $form.find('button').prop('disabled', false);
            },
            success: function (data) {
				// Formular pre stiahnutie materialov
				if ($form.hasClass('docs-form')) {
					$('.prod-docs__link').each(function(item, value) {
						$(this).attr('href', $(this).attr('data-url'));
					});

					window.open($('#material').val(), '_blank');

					$('.modalDocs').fadeOut();
				}

                //Vymažeme inputy
                $form[0].reset();

                //Zobrazíme success hlášku
                if ($form.find('input[name="id"]').val() == 8) {
					$form.replaceWith('<div class="con-form__thank-you">Ďakujeme za váš e-mail, naše novinky sú už na ceste k vám.</div>');
					setCookie('blog_cookie', 'yes');
					dataLayer.push({
						'event': 'newsletter_blog',
					});
				} else if ($form.find('input[name="id"]').val() == 9) {
					$form.replaceWith('<div class="con-form__thank-you">Ďakujeme za váš e-mail, v krátkom čase vás budeme kontaktovať.</div>');
					setCookie('product_cookie', 'yes');
					dataLayer.push({
						'event': 'newsletter_produkty',
					});
				} else if ($form.find('input[name="id"]').val() == 5) {
					$form.siblings('.title').remove();
					$form.siblings('.why-con__desc').remove();
					$form.replaceWith('<div class="con-form__thank-you">Registrácia prebehla úšpešne! Ďakujeme za Váš záujem.<br><br><div class="con-form__thank-you--small">V prípade registrácie na online webinár Vám bude deň pred konaním eventu na e-mail uvedený v registračnom formulári odoslaný link na pripojenie sa.</div></div>');
				} else {
					$form.replaceWith('<div class="con-form__thank-you">Vaša správa bola úspešne odoslaná!</div>');
				}


                if($form.find('input[name="id"]').val() == 3 && $('#formProduct', $form)) {
                    dataLayer.push({
                        'event': 'form_submit',
                        'form_product': $('#formProduct', $form).val()
                    });
                }

                //Povolíme button
                $form.find('button').prop('disabled', false);

                if ($form.hasClass('con__form')) {
                    dataLayer.push({
                        'event': 'odoslany_formular_potrebujem_pomoc',
                    });
                    window._adftrack.push({
                        HttpHost: 'track.adform.net',
                        pm: 2460324,
                        divider: encodeURIComponent('|'),
                        pagename: encodeURIComponent('odoslany_formular_potrebujem_pomoc')
                    });

                }

                //Asseco APplus
                if ($('#formProduct', $form) && $('#formProduct', $form).val() == 'Asseco APplus') {
                    dataLayer.push({
                        'event': 'odoslany_formular_applus',
                    });
                    window._adftrack.push({
                        HttpHost: 'track.adform.net',
                        pm: 2460324,
                        divider: encodeURIComponent('|'),
                        pagename: encodeURIComponent('doslany_formular_applus')
                    });
                    // pre istotu ešte aj takto, možno poslali s preklepom
                    window._adftrack.push({
                        HttpHost: 'track.adform.net',
                        pm: 2460324,
                        divider: encodeURIComponent('|'),
                        pagename: encodeURIComponent('odoslany_formular_applus')
                    });
                }
                //Asseco HELIOS iNuvio
                if ($('#formProduct', $form) && $('#formProduct', $form).val() == 'Asseco HELIOS iNuvio') {
                    dataLayer.push({
                        'event': 'odoslany_formular_helios_orange',
                    });
                    window._adftrack.push({
                        HttpHost: 'track.adform.net',
                        pm: 2460324,
                        divider: encodeURIComponent('|'),
                        pagename: encodeURIComponent('odoslany_formular_helios_orange')
                    });
                }
            }
        });

        return false;
    });

	// Cookies pre modalne okna na 14 dni
	function setCookie(key, value) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (14 * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
    }

    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    }

    if (getCookie('blog_cookie') == null) {
		setTimeout(function() {
			$('.blogModal').fadeIn(200);
		}, 20000);
    }

	if (getCookie('product_cookie') == null) {
        setTimeout(function() {
			$('.productModal').fadeIn(200);
		}, 20000);
    }

    $('.blogModalClose').on('click', function (event) {
        setCookie('blog_cookie', 'yes');
        $('.blogModal').fadeOut(200);
    });

	$('.productModalClose').on('click', function (event) {
        setCookie('product_cookie', 'yes');
        $('.productModal').fadeOut(200);
    });

    //$('.has-error')

    // Lazy loading na logach referencii
    window.lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    // Vyska ciary v timeline v Kariere
    function timelineHeight () {
        $('.car-val__line').css('height', $('.car-box').last().offset().top - $('.car-box').first().offset().top)
    }

    if ($('.car-val__line').length) {
        timelineHeight();

        $(window).resize(function () {
            timelineHeight();
        });
    }


    $('.sol .con-tabs__item').click(function (e) {
        e.preventDefault();

        $.get('/odvetvove-riesenia/load/' + $(this).data('category'), function (response) {
            history.pushState({}, response.title, response.slug);
            document.title = response.title;
            $('.sol__ben').html(response.icons);
            $('.sol__points').html(response.sol_points);

            window.lazyLoadInstance.update();
        });

        return false;
    });

    $('.prod-tabtab__link').click(function (e) {
        e.preventDefault();

        $('.prod-tabtab__link').removeClass('prod-tabtab__link--active');
        $(this).addClass('prod-tabtab__link--active');
        $('.prod-tabtab__content').removeClass('prod-tabtab__content--active');
        $('.prod-tabtab__content:nth(' + $(this).index() + ')').addClass('prod-tabtab__content--active');
    });

    if (location.hash == '#info') {
        setTimeout(function () {
            $('html, body').stop().animate({
                scrollTop: $('#info').offset().top - 104
            }, 800);
        }, 20);
    }

    function showResult () {
        $.post('/vianoce/show', { _token: Asseco._token }, function () {
            setTimeout(function () {
                $('.v-modal').css("display", "flex").hide().fadeIn(400);
            }, 700);
        });
    }

    $('.vianoce__ukaz').on('click', function (e) {
        e.preventDefault();

        $('.scratch__canvas').fadeOut(300);
        $(this).fadeOut(300);

        showResult();
    });

    /* Vaanoce */
    // var Scratch = (function () {
    //     var BRUSH_B64 = 'data:image/png;base64,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';
    //     var distanceBetween = function (point1, point2) {
    //         var a = point2.x - point1.x;
    //         var b = point2.y - point1.y;
    //         return Math.sqrt((a * a) + (b * b));
    //     }
    //     var angleBetween = function (point1, point2) {
    //         return Math.atan2(point2.x - point1.x, point2.y - point1.y);
    //     }

    //     function Scratch(canvas/*HTMLCanvasElement*/, coverImgURL/*string*/, completeCallback/*Function*/) {
    //         var self = this;
    //         this.canvas = canvas;
    //         this.autoDrawing = false;
    //         this.completeCallback = completeCallback;
    //         this.supportTouch = ('ontouchstart' in window);
    //         this.isDrawing = false;
    //         this.lastPoint = {x: 0, y: 0};
    //         this.context = canvas.getContext('2d');
    //         this.handleMouseDown = this.handleMouseDown.bind(this);
    //         this.handleMouseMove = this.handleMouseMove.bind(this);
    //         this.handleMouseUp = this.handleMouseUp.bind(this);
    //         this.brushImg = new Image();
    //         this.brushImg.src = BRUSH_B64;
    //         this.saveMouse = [];
    //         this.saveLastPoint = [];
    //         this.started = false;
    //         this.tempCanvas=document.createElement("canvas");
    //         this.tctx=this.tempCanvas.getContext("2d");
    //         // width 80, height 50
    //         /* this.brushImg.onload = ()=>{
    //           console.log(this.brushImg.width);
    //           console.log(this.brushImg.height);
    //         } */

    //         var element = document.querySelector('.scratch');
    //         var img = new Image();
    //         this.img = img;
    //         img.src = coverImgURL;
    //         img.onload = function () {
    //             element.classList.add('animate');

    //             // Zobrazíme obrázky až keď sa nám načíta obrázčok
    //             $('.vianoce__icon').show();

    //             var ctx = self.context;
    //             var w = img.width;
    //             var h = img.height;

    //             self.canvas.width = w;
    //             self.canvas.height = h;
    //             ctx.drawImage(img, 0, 0);

    //             element.addEventListener('touchstart', self.handleMouseDown);
    //             window.addEventListener('touchmove', self.handleMouseMove);
    //             window.addEventListener('touchend', self.handleMouseUp);
    //             element.addEventListener('mousedown', self.handleMouseDown);
    //             window.addEventListener('mousemove', self.handleMouseMove);
    //             window.addEventListener('mouseup', self.handleMouseUp);

    //             if(window.autoDraw && window.autoDraw.length > 0) {
    //                 self.autoDraw(window.autoDraw);
    //             }
    //         };
    //     }

    //     Scratch.prototype.getMousePosition = function (event) {
    //         const pageScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    //         const pageScrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
    //         const evt = this.supportTouch ? event.touches[0] : event;
    //         const rect = this.canvas.getBoundingClientRect();
    //         if (window.convertPointFromPageToNode) {
    //             return window.convertPointFromPageToNode(document.querySelector('.scratch'), evt.pageX, evt.pageY);
    //         }
    //         var width = $(window).outerWidth();
    //         var scaleFactor = 1.00;
    //         if(width <= 1200 && width > 992) {
    //             scaleFactor = 0.80;
    //         }
    //         if(width <= 768) {
    //             scaleFactor = 0.80;
    //         }
    //         if(width <= 640) {
    //             scaleFactor = 0.60;
    //         }
    //         if(width <= 450) {
    //             scaleFactor = 0.50;
    //         }
    //         if(width <= 360) {
    //             scaleFactor = 0.42;
    //         }
    //         const mouse = {
    //             x: (evt.pageX - rect.left - pageScrollLeft) / scaleFactor,
    //             y: (evt.pageY - rect.top - pageScrollTop) / scaleFactor,
    //         };
    //         if(this.saveLastPoint.length == 0 || (this.saveLastPoint.x != mouse.x && this.saveLastPoint.y != mouse.y)) {
    //             window.autoDraw.push(mouse);
    //             this.saveLastPoint = mouse;
    //         }
    //         return mouse;
    //     };
    //     Scratch.prototype.handleMouseDown = function (event) {
    //         event.preventDefault();
    //         this.lastPoint = this.getMousePosition(event);
    //         this.isDrawing = true;
    //         $('.vianoce__helper').hide();
    //     }
    //     Scratch.prototype.handleMouseMove = function (event) {
    //         if (!this.isDrawing || this.autoDrawing) {
    //             return;
    //         }
    //         var position = this.getMousePosition(event);
    //         this.draw(position);
    //         if (this.completeCallback) {
    //             this.completeCallback.call(this, this.getFilledInPixels(32));
    //         }
    //     }
    //     Scratch.prototype.autoDraw = function (positions) {
    //         this.autoDrawing = true;
    //         this.lastPoint = positions[0];
    //         var self = this;

    //         $.each(positions, function(index, item){
    //             self.draw(item);

    //             if(index >= positions.length-1){
    //                 self.autoDrawing = false;
    //             }
    //         });

    //         if (this.completeCallback) {
    //             this.completeCallback.call(this, this.getFilledInPixels(32));
    //         }
    //     }
    //     Scratch.prototype.draw = function (position) {
    //         var dist = distanceBetween(this.lastPoint, position);
    //         var angle = angleBetween(this.lastPoint, position);
    //         var ctx = this.context;
    //         var x, y;
    //         for (var i = 0; i < dist; i += 1) {
    //             x = this.lastPoint.x + (Math.sin(angle) * i);
    //             y = this.lastPoint.y + (Math.cos(angle) * i);
    //             ctx.globalCompositeOperation = 'destination-out';
    //             ctx.drawImage(this.brushImg, x - 40, y - 25)
    //         }
    //         this.lastPoint = position;
    //     }
    //     Scratch.prototype.handleMouseUp = function (event) {
    //         this.isDrawing = false;

    //         var $this = this;

    //         //Uložíme do dtb aktulny stav zotretia
    //         $.post('vianoce/mouse', {
    //             mouse: JSON.stringify(window.autoDraw),
    //             _token: Asseco._token,
    //         }, function() {
    //             //
    //         });

    //         if($this.started == false) {
    //             $.post('/vianoce/start', {_token: Asseco._token}, function() {
    //                 $this.started = true;
    //             });
    //         }
    //     }
    //     Scratch.prototype.getFilledInPixels = function (stride/*number*/) {
    //         if (!stride || stride < 1) {
    //             stride = 1;
    //         }
    //         var pixels = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
    //         var data = pixels.data;
    //         var length = data.length;
    //         var total = (length / stride);
    //         var count = 0;
    //         for (var i = count = 0; i < length; i += stride) {
    //             if (parseInt(data[i]) === 0) {
    //                 count++;
    //             }
    //         }

    //         return Math.round((count / total) * 100);
    //     }
    //     Scratch.prototype.destory = function () {
    //         this.canvas.removeEventListener('mousedown', this.handleMouseDown);
    //         this.canvas.removeEventListener('mousemove', this.handleMouseMove);
    //         this.canvas.removeEventListener('mouseup', this.handleMouseUp);
    //         this.canvas.removeEventListener('touchstart', this.handleMouseDown);
    //         this.canvas.removeEventListener('touchmove', this.handleMouseMove);
    //         this.canvas.removeEventListener('touchend', this.handleMouseUp);
    //         this.canvas.parentNode.removeChild(this.canvas);
    //     }
    //     return Scratch;
    // })();


    // var vianoceResult = false;
    // if(document.querySelectorAll('.scratch__canvas').length != 0) {
    //     new Scratch(document.querySelector('.scratch__canvas'), '/images/vianoce/darceky.png', function (perc) {
    //         //Ak je odokryté ako viac ako 82% zobrazíme výhru
    //         if(perc > 82 && vianoceResult == false) {
    //             $('.scratch__canvas').fadeOut(300);
    //             $('.vianoce__ukaz').fadeOut(300);

    //             showResult();
    //             vianoceResult = true;

    //             //Ak je odokryté ako viac ako 50% tak zobrazíme button na odokrytie celej časti
    //         } else if (perc > 44) {
    //             $('.vianoce__ukaz').fadeIn(300);
    //         }
    //     });
    // }

    // function fallbackCopyTextToClipboard(text) {
    //     var textArea = document.createElement("textarea");
    //     textArea.value = text;

    //     // Avoid scrolling to bottom
    //     textArea.style.top = "0";
    //     textArea.style.left = "0";
    //     textArea.style.position = "fixed";

    //     document.body.appendChild(textArea);
    //     textArea.focus();
    //     textArea.select();

    //     try {
    //         var successful = document.execCommand('copy');
    //         var msg = successful ? 'successful' : 'unsuccessful';
    //     } catch (err) {

    //     }

    //     document.body.removeChild(textArea);
    // }
    // function copyTextToClipboard(text) {
    //     if (!navigator.clipboard) {
    //         fallbackCopyTextToClipboard(text);
    //         return;
    //     }
    //     navigator.clipboard.writeText(text).then(function() {
    //     }, function(err) {

    //     });
    // }

    // $('.v-film__copy').click(function(e) {
    //     e.preventDefault();

    //     copyTextToClipboard($('.v-film__input').val());
    //     $('.v-film__input').select();
    // });

    // //Stiahnutie hudby
    // $('.v-music').on('submit', function(e) {
    //     e.preventDefault();

    //     var $this = $(this);

    //     $.ajax({
    //         method: $this.attr('method'),
    //         url: $this.attr('action'),
    //         data: $this.serialize(),
    //         success: function (data) {
    //             $this.prop('disabled', true);
    //             $this.find('button').parent().remove();

    //             window.open(data.url, '_blank');
    //         },
    //     });

    // });

    //Načítať prípadové študie
    $(document).on('click', '.logo-box--load', function (e) {
        e.preventDefault();

        let $this = $(this);

        $.get($this.attr('href'), function (response) {
            $this.before(response.html);
            $this.remove();

            window.lazyLoadInstance.update();
        });
    });

    //Infinity scroll pagination noviniek
    if ($('.scrolling-pagination').length) {
        $('.news-posts__pagination').hide();
        $(function () {
            $('.scrolling-pagination').jscroll({
                autoTrigger: true,
                padding: 0,
                nextSelector: '.news-posts__pagination li.active + li a',
                contentSelector: 'div.scrolling-pagination',
                callback: function () {
                    $('.news-posts__pagination').remove();
                    window.lazyLoadInstance.update();
                }
            });
        });

    }


    //helios mam zaujem
    $(document).on('click', '.prod-box__inner--helios .prod-box__button', function (e) {
        dataLayer.push({
            'event': 'helios_mam_zaujem',
        });
    });
    //applus mam zaujem
    $(document).on('click', '.prod-box__inner--applus .prod-box__button', function (e) {
        dataLayer.push({
            'event': 'applus_mam_zaujem',
        });
    });
    $(document).on('click', '.button-arrow', function (e) {
        //helios viac informacii
        if ($(this).prev('.prod-box__inner--helios').length) {
            dataLayer.push({
                'event': 'helios_viac_informacii',
            });
        }
        //applus viac informacii
        if ($(this).prev('.prod-box__inner--applus').length) {
            dataLayer.push({
                'event': 'applus_viac_informacii',
            });
        }
    });

});




$(function(){


    $('.cookies-bar__more').click(function(e){
        e.preventDefault();

        $('.cookies-bar').fadeOut(300, function(){
            $('.cookies-detail').fadeIn(300);
        });
    });

	$('.cookiesTab').on('click', function(event) {
		event.preventDefault();

		$('.cookiesTab').removeClass('cookies-detail__tab--active');
		$('.cookiesTabDetail').hide();
		$(this).addClass('cookies-detail__tab--active');
		$($(this).attr('href')).fadeIn(150);
	});

	$('.cookiesDetailBtn').on('click', function(event) {
		event.preventDefault();

		$(this).prev('.cookiesDetailIcon').toggleClass('cookies-toggle__icon--active');
		$($(this).attr('href')).slideToggle(150);
	});

	$('.cookiesDescMore').on('click', function(event) {
		$(this).hide();
		$(this).next('.cookiesDescMoreText').fadeIn(150);
	});

    $('.povolit-vsetko').click(function(e){
        e.preventDefault();
        $('#bar_analyticke').prop('checked', 'checked');
        $('#bar_marketingove').prop('checked', 'checked');
        $('#detail_analyticke_2').prop('checked', 'checked');
        $('#detail_marketingove_2').prop('checked', 'checked');
        setCookie('gdpr', 'gtm11');

        initGtm(true);
    });

    $('.odmietnut-vsetko').click(function(e){
        e.preventDefault();
        var query1 = '#bar_analyticke:checked';
        var query2 = '#bar_marketingove:checked';

        if($(this).hasClass('alt')){
            var query1 = '#detail_analyticke_2:checked';
            var query2 = '#detail_marketingove_2:checked';
        }

        if($(query1 + ', ' + query2).length > 0){
            setCookie(
                'gdpr',
                'gtm' + ( $(query1).length > 0 ? 1 : 0 )+ ( $(query2).length > 0 ? 1 : 0 )
            );
        } else {
            var gdpr = getCookie('gdpr');
            if(gdpr){
                var num = gdpr.replace('none', '');
                if(num.length > 0){
                    num = num.replace('_', '');
                    num = parseInt(num, 10);

                    if(typeof(num) == 'NaN' || num == 'NaN'){
                        num = 0;
                    }
                } else {
                    num = 0;
                }

                if(isNaN(num)){
                    num = 0;
                }

                setCookie('gdpr', 'none_' + (num + 1));
            } else {
                setCookie('gdpr', 'none_0');
            }
        }

        initGtm(true);
    });

    $('#bar_analyticke, #bar_marketingove, #detail_analyticke_2, #detail_marketingove_2').change(function(e){
        var id = $(this).attr('id');
        var ref = null;
        if(id == 'bar_analyticke'){
            ref = 'detail_analyticke_2';
        } else if(id == 'bar_marketingove'){
            ref = 'detail_marketingove_2';
        } else if(id == 'detail_analyticke_2'){
            ref = 'bar_analyticke';
        } else if(id == 'detail_marketingove_2'){
            ref = 'bar_marketingove';
        }

        $('#' + ref).prop('checked', $(this).prop('checked'));


        if($('#bar_analyticke:checked, #bar_marketingove:checked, #detail_analyticke_2:checked, #detail_marketingove_2:checked').length > 0){
            $('.odmietnut-vsetko').text('Povoliť výber');
        } else {
            $('.odmietnut-vsetko').text('Odmietnuť');
        }
    });

    // https://javascript.info/cookie
    var getCookie = function(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    // Example of use:
    // setCookie('user', 'John', {secure: true, 'max-age': 3600});
    var setCookie = function(name, value, options = {}) {

        options = {
            path: '/',
            secure: true,
            domain: window.location.host,
            'max-age': 2678400,
            ...options
        };

        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }

    var setSession = function(name, value){

        let options = {
            path: '/',
            secure: true,
            domain: window.location.host
        };

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }

    var deleteCookie = function(name) {
        setCookie(name, "", {
            'max-age': -1
        })
    }

    window.gdprSet = function(){
        $('.cookies-bar, .cookies-shade').show();
    };

    var initGtm = function(andHide){
        var gdpr = getCookie('gdpr');

        if(gdpr){
            if(gdpr.indexOf('none') > -1){
                // bez gtm

                var num = gdpr.replace('none', '');
                if(num.length > 0){
                    num = num.replace('_', '');
                    num = parseInt(num, 10);
                } else {
                    num = 1;
                }

                if(num < 4){
                    // mali by sme ukazat okno 3x
                    // pozrieme ci mame session cookie ktora nas blokuje
                    var sessionCookie = getCookie('gdpr_s');
                    if(!sessionCookie){
                        // nie je .. mozme pokracovat

                        var isChrome = navigator && navigator.userAgent && navigator.userAgent.indexOf('Chrome') > -1;
                        if(isChrome){
                            // https://github.com/js-cookie/js-cookie/wiki/Frequently-Asked-Questions#why-the-browser-does-not-remove-the-cookies-after-i-close-it
                            setCookie('gdpr_s', true, { 'max-age': 300 });
                        } else {
                            setSession('gdpr_s', true);
                        }

                        gdprSet();
                    }
                }
            } else {
                // vlozime gtm
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-WG3CFNX');

                var analyticke = false;
                var marketingove = false;

                // povieme gtm ake scripty su povolene
                if(gdpr == 'gtm11'){
                    window.dataLayer.push({ event: 'analyticke', value: 1 });
                    window.dataLayer.push({ event: 'marketingove', value: 1 });

                    analyticke = true;
                    marketingove = true;
                } else if(gdpr == 'gtm10'){
                    window.dataLayer.push({ event: 'analyticke', value: 1 });
                    window.dataLayer.push({ event: 'marketingove', value: 0 });

                    analyticke = true;
                    marketingove = false;
                } else if(gdpr == 'gtm01'){
                    window.dataLayer.push({ event: 'analyticke', value: 0 });
                    window.dataLayer.push({ event: 'marketingove', value: 1 });

                    analyticke = false;
                    marketingove = true;
                }

                gtag("consent", "update", {
                    ad_storage: marketingove ? "granted" : "denied", // marketingove
                    ad_user_data: marketingove ? "granted" : "denied",  // marketingove
                    ad_personalization: marketingove ? "granted" : "denied",  // marketingove
                    analytics_storage: analyticke ? "granted" : "denied", // analytics
                    functionality_storage: "granted",
                    personalization_storage: "granted",
                    security_storage: "granted"
                });

                gtag("set", "ads_data_redaction", true);
                gtag("set", "url_passthrough", true);

                if(analyticke){
                    window.ga=function(){ga.q.push(arguments)};ga.q=[];ga.l=+new Date;ga('create','UA-76544773-1','auto');ga('send','pageview');
                    (function(d,t){var g=d.createElement(t),s=d.getElementsByTagName(t)[0];
                    g.src=('https:'==location.protocol?'//ssl':'//www')+'.google-analytics.com/analytics.js';
                    s.parentNode.insertBefore(g,s)}(document,'script'));

                    // heatmap
                    setTimeout(function(){var a=document.createElement("script");var b=document.getElementsByTagName("script")[0];a.src=document.location.protocol+"//script.crazyegg.com/pages/scripts/0049/5968.js?"+Math.floor(new Date().getTime()/3600000);a.async=true;a.type="text/javascript";b.parentNode.insertBefore(a,b)}, 1);
                }

                if(marketingove) {
                    // adftrack script ---- zaciatok
                    window._adftrack.push({
                        HttpHost: 'track.adform.net',
                        pm: 2460324
                    });
                    (function () {
                        var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://s2.adform.net/banners/scripts/st/trackpoint-async.js'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x);
                    })();
                    // adftrack script ---- koniec

                    // leady script ---- zaciatok
                    var leady_track_key='59tbxMf14TpZ3itL';
                    (function(d,t){var g=d.createElement(t),s=d.getElementsByTagName(t)[0];
                        g.src='https://t.leady.com/59tbxMf14TpZ3itL/L.js';
                        s.parentNode.insertBefore(g,s)}(document,'script'));
                    // leady script ---- zaciatok

                    // crimtan
                    (function(d,t){var g=d.createElement(t),s=d.getElementsByTagName(t)[0];
                        g.src='https://i.ctnsnet.com/int/integration?pixel=37076378&nid=2141089&cont=s';
                        s.parentNode.insertBefore(g,s)}(document,'script'));
                }

                if(getCookie('gdpr_tr')){
                    deleteCookie('gdpr_tr');
                }
            }
        } else {
            // ziadna cookie ani neexistuje, treba zobrazit cookie bar, aby sa uzivatel rozhodol
            gdprSet();
        }

        if(andHide){
            $('.cookies-bar, .cookies-detail, .cookies-shade').hide();
        }
    }

    initGtm();
});
